"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchNotificationData = fetchNotificationData;
exports.fetchNotificationUnreadCount = fetchNotificationUnreadCount;
exports.fetchNotificationUnseenCount = fetchNotificationUnseenCount;
exports.updateNotificationRead = updateNotificationRead;
require("core-js/modules/es.array.concat.js");
var _api = _interopRequireDefault(require("../http/api"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * fetch number of unseen notification
 */
function fetchNotificationUnseenCount() {
  return _api.default.get("/website-nav/web-api/v1/notification/unseen");
}
function fetchNotificationData() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  return _api.default.get("/website-nav/web-api/v1/notification?offset=".concat(offset, "&limit=").concat(limit));
}
function fetchNotificationUnreadCount() {
  return _api.default.get("/website-nav/web-api/v1/notification/unread");
}

/**
 * update a given notification activity as rea
 */
function updateNotificationRead(groupId) {
  return _api.default.put("/website-nav/web-api/v1/notification/mark-read", {
    group: groupId
  });
}